import PropTypes from 'prop-types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import InviteLink from '../invite-link'
import SEO from '../seo'
import FlexConfiguration from '../shared/flex-configuration'
import Button from '../tailwind/Button'
import FeatureSection from './flex/feature-section'

const Header = ({ career }) => {
  const { t } = useTranslation()

  return (
    <div className='md:flex md:items-center'>
      <div className='md:flex-auto'>
        <h1 className='text-xl font-semibold text-gray-900'>
          {t('career.flex.title')}
        </h1>
        <p className='mt-2 max-w-lg text-sm text-gray-700 lg:max-w-2xl'>
          {t('career.flex.description', { career_title: career.title })}
        </p>
      </div>
    </div>
  )
}

Header.propTypes = { career: PropTypes.object.isRequired }

const Divider = () => {
  return <div className='my-8 h-px w-full max-w-4xl bg-gray-200' />
}

const Flex = ({ career, updateHandler }) => {
  const { t } = useTranslation()

  const components = JSON.parse(career.app_settings?.components || '{}')

  const [openCreateFlexModal, setOpenCreateFlexModal] = useState(false)
  const [openUpdateFlexModal, setOpenUpdateFlexModal] = useState(false)

  return (
    <div className='mb-16'>
      <SEO title={t('seo.titles.career_pbc_settings')} />
      {!components.customLandingPageFields && (
        <>
          <div className='h-6' />
          <Header career={career} />
          <div className='h-6' />
          <FeatureSection
            action={
              <Button.PrimaryXL
                text={t('career.flex.create_flex.create_action')}
                onClick={() => setOpenCreateFlexModal(true)}
              />
            }
          />
          <FlexConfiguration
            open={openCreateFlexModal}
            setOpen={setOpenCreateFlexModal}
            entity={career}
            updateHandler={({ input, onSuccess, onError }) => {
              updateHandler({ input, onSuccess, onError })
            }}
            type='career'
            create
          />
        </>
      )}
      {components.customLandingPageFields && (
        <>
          <div className='h-6' />
          <Header career={career} />
          <div className='mt-4 max-w-3xl'>
            <Button.SecondaryBase
              text={t('career.flex.update_action')}
              onClick={() => setOpenUpdateFlexModal(true)}
            />
          </div>
          <Divider />
          <div>
            <h1 className='text-lg font-semibold text-gray-900'>
              {t('career.flex.feature_section.link_name')}
            </h1>
            <p className='mt-1 max-w-lg text-sm text-gray-700 lg:max-w-2xl'>
              {t('career.flex.feature_section.link_description')}
            </p>
            <div className='mt-3 max-w-3xl'>
              <InviteLink careerID={career.id} />
            </div>
          </div>
          {/* Render the FlexConfiguration component outside the div to avoid nesting issues */}
          <FlexConfiguration
            open={openUpdateFlexModal}
            setOpen={setOpenUpdateFlexModal}
            entity={career}
            updateHandler={({ input, onSuccess, onError }) => {
              updateHandler({ input, onSuccess, onError })
            }}
            type='career'
            update
          />
        </>
      )}
    </div>
  )
}

Flex.propTypes = {
  career: PropTypes.object.isRequired,
  updateHandler: PropTypes.func.isRequired
}

export default Flex
